var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "DialogBase",
        {
          attrs: {
            title: "Danh sách tài khoản VA",
            visible: _vm.showAccountVADialog,
            width: "1350px",
            "panel-icon": "el-icon-bank",
            "panel-title": "DANH SÁCH TÀI KHOẢN ẢO (VA)",
            "panel-subtitle":
              "Danh sách các tài khoản ảo liên kết và cấu hình mã QR động cho học sinh.",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showAccountVADialog = $event
            },
            "before-close": _vm.handleClose,
            cancel: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading.table,
                      expression: "loading.table",
                    },
                  ],
                  ref: "multipleTable",
                  staticClass: "modern-table",
                  attrs: {
                    "element-loading-text":
                      "Đang tải danh sách tài khoản ảo...",
                    "element-loading-spinner": "el-icon-loading",
                    "element-loading-background": "rgba(255,255,255,0.7)",
                    "highlight-current-row": "",
                    data: _vm.listVA,
                    border: "",
                    "max-height": _vm.tableMaxHeight,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "STT",
                      width: "55",
                      align: "center",
                      fixed: "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Số tài khoản ảo (VA)",
                      prop: "va",
                      "min-width": "200",
                      align: "center",
                      fixed: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("code", { staticClass: "code-badge-blue" }, [
                              _vm._v(_vm._s(row.va)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "ID VA",
                      prop: "idVa",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("code", { staticClass: "code-badge" }, [
                              _vm._v(_vm._s(row.idVa)),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Tên gợi nhớ",
                      prop: "label",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "label-text" }, [
                              _vm._v(_vm._s(row.label || "—")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Hiển thị QR",
                      prop: "showQR",
                      align: "center",
                      width: "130",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("el-checkbox", {
                              attrs: {
                                disabled: !row.active || !_vm.showQRMainAccount,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleChangeShowVA(row)
                                },
                              },
                              model: {
                                value: row.showQR,
                                callback: function ($$v) {
                                  _vm.$set(row, "showQR", $$v)
                                },
                                expression: "row.showQR",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Tiền vào trong tháng",
                      prop: "sumMoneyIn",
                      align: "right",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "money-text green" }, [
                              _vm._v(
                                _vm._s(_vm._f("formatCurrency")(row.sumMoneyIn))
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Tiền ra trong tháng",
                      prop: "sumMoneyOut",
                      align: "right",
                      "min-width": "180",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("span", { staticClass: "money-text red" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatCurrency")(row.sumMoneyOut)
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Trạng thái",
                      prop: "active",
                      align: "center",
                      width: "160",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "status-badge",
                                class: row.active ? "online" : "offline",
                              },
                              [
                                _c("span", { staticClass: "dot" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      row.active ? "Hoạt động" : "Tạm khóa"
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "Tác vụ điều khiển",
                      align: "center",
                      width: "240",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _vm.checkPermission([
                              "bank-connection-manager-va-unlink",
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "danger",
                                      icon: "el-icon-lock",
                                      disabled: !row.active,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.disableAccount(row.idVa)
                                      },
                                    },
                                  },
                                  [_vm._v("\n              Khóa\n            ")]
                                )
                              : _vm._e(),
                            _vm.checkPermission([
                              "bank-connection-manager-va-link",
                            ])
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: "success",
                                      icon: "el-icon-unlock",
                                      disabled:
                                        row.active ||
                                        _vm.bank.bankApiConnected === false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.enableBank(row.idVa)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              Mở khóa\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              {
                staticClass:
                  "custom-footer-bar flex justify-between w-full align-center",
              },
              [
                _c(
                  "div",
                  { staticClass: "footer-left" },
                  [
                    !_vm.actionToAdmin
                      ? _c(
                          "el-dropdown",
                          { on: { command: _vm.handleCommand } },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "gradient-btn-small green",
                                attrs: {
                                  type: "success",
                                  icon: "el-icon-plus",
                                },
                              },
                              [
                                _vm._v("\n              Tác vụ VA "),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right",
                                }),
                              ]
                            ),
                            _c(
                              "el-dropdown-menu",
                              {
                                staticClass: "modern-dropdown-menu",
                                attrs: { slot: "dropdown" },
                                slot: "dropdown",
                              },
                              [
                                _vm.checkPermission([
                                  "bank-connection-manager-va-create",
                                ])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: "addAccountBankVA",
                                          icon: "el-icon-plus",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                Thêm tài khoản ảo VA\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _c("span"),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "footer-right" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-cancel",
                        on: { click: _vm.handleClose },
                      },
                      [_vm._v("Đóng hộp thoại")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]),
        ],
        2
      ),
      _c("OTPAuthenticationAndVAToKienLongBankDialog", {
        attrs: {
          isOTPAuthenticationKienLongBankDialog:
            _vm.isOTPAuthenticationKienLongBankDialog,
          bank: _vm.bank,
        },
        on: {
          closeDialog: _vm.handleCloseOTPAuthenticationKienLongBankDialog,
          closeDialogAll: _vm.handleCloseAllOTPAuthenticationKienLongBankDialog,
        },
      }),
      _c("OTPAuthenticationAndVAToOCBDialog", {
        attrs: {
          isOTPAuthenticationOCBDialog: _vm.isOTPAuthenticationOCBDialog,
          bank: _vm.bank,
        },
        on: {
          closeDialog: _vm.handleCloseOTPAuthenticationOCBDialog,
          closeDialogAll: _vm.handleCloseAllOTPAuthenticationOCBDialog,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }